// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.content-layout {
  background-color: #e4e6eb !important;
  padding-left: 0px !important;
  margin: 0px !important;
  display: flex !important;
  justify-content: flex-start;
  align-items: flex-start;
  height: 100vh;
}

.view-container-page {
  background-color: rgb(247, 248, 249) !important;
  padding-right: 0 !important;
  padding-left: 0 !important;
  margin-right: 0 !important;
  margin-left: 0 !important;
  height: "100%";
  margin-top: -1.5rem;
}

.container-quickAccess-logged-layout {
  padding-left: 0px !important;
  position: sticky !important;
  top: 0px;
  background-color: #e4e6eb;
}

.container-data-layout {
  height: 100vh;
  background-color: #e4e6eb !important;
  justify-content: space-around;
  align-items: flex-start;
  align-self: flex-start;
}

.children {
  min-height: 68vh;
}

.quick-access-mobile-displaced {
  margin-top: 0.5rem !important;
  transition: margin-top 0.3s; /* Add a transition for smooth animation */
}

.navbar-component {
  padding-right: 0;
  width: calc(100% - 250px);
}

.loginbutton-component {
  display: flex;
  width: 250px;
  padding-left: 0px;
}

.navbar-layout {
  align-self: center;
  margin: 50px 5px 30px 5px;
}
.navbar-layout .navbar-light {
  background-color: #ffc14d;
  border-top-left-radius: 37px;
  border-bottom-left-radius: 37px;
  height: 3rem;
}

.container-quick-access-layout {
  align-self: flex-start;
  position: sticky !important;
  top: 0px !important;
  height: 100vh;
  background-color: rgba(0, 0, 0, 0);
  padding-left: 0px !important;
}

@media screen and (max-width: 1200px) {
  .view-container-page {
    padding: 0 !important;
    margin: 0px 64px !important;
    width: calc(100vw - 65px) !important;
    height: "100%";
  }
  .container-quickAccess-logged-layout {
    display: none !important;
  }
  .container-quick-access-layout {
    display: none;
  }
}
@media (max-width: 576px) {
  .view-container-page {
    background-color: #f7f8f9;
    padding: 0 !important;
    margin: 0px 0px !important;
    width: 100% !important;
  }
  .navbar-component {
    padding-right: 0;
    width: calc(100% - 210px);
  }
  .loginbutton-component {
    display: flex;
    width: 210px;
    padding-left: 0px;
  }
}
.quick-access-mobile {
  display: none;
}

@media (max-width: 576px) {
  .quick-access-mobile {
    display: flex;
    background-color: #ffffff;
    border-radius: 17px;
    width: 85%;
    margin: auto;
  }
}

`, "",{"version":3,"sources":["webpack://./src/sass/layout/layout/layout.scss","webpack://./src/sass/layout/layout/layout.css","webpack://./src/sass/utilities/_mixins.scss","webpack://./src/sass/utilities/_variables.scss"],"names":[],"mappings":"AAGA;EACE,oCAAA;EACA,4BAAA;EACA,sBAAA;EACA,wBAAA;EACA,2BAAA;EACA,uBAAA;EACA,aAAA;ACFF;;ADKA;EEJE,+CAAA;EACA,2BAAA;EACA,0BAAA;EACA,0BAAA;EACA,yBAAA;EFEA,cAAA;EACA,mBAAA;ACEF;;ADCA;EACE,4BAAA;EACA,2BAAA;EACA,QAAA;EACA,yBAAA;ACEF;;ADCA;EACE,aAAA;EACA,oCAAA;EACA,6BAAA;EACA,uBAAA;EACA,sBAAA;ACEF;;ADCA;EACE,gBAAA;ACEF;;ADCA;EACE,6BAAA;EACA,2BAAA,EAAA,0CAAA;ACEF;;ADCA;EACE,gBAAA;EACA,yBAAA;ACEF;;ADCA;EACE,aAAA;EACA,YAAA;EACA,iBAAA;ACEF;;ADEA;EACE,kBAAA;EACA,yBAAA;ACCF;ADAE;EACE,yBAAA;EACA,4BAAA;EACA,+BAAA;EACA,YAAA;ACEJ;;ADEA;EACE,sBAAA;EACA,2BAAA;EACA,mBAAA;EACA,aAAA;EACA,kCGhEY;EHiEZ,4BAAA;ACCF;;ADEA;EACE;IACE,qBAAA;IACA,2BAAA;IACA,oCAAA;IACA,cAAA;ECCF;EDEA;IACE,wBAAA;ECAF;EDEA;IACE,aAAA;ECAF;AACF;ADGA;EACE;IACE,yBAAA;IACA,qBAAA;IACA,0BAAA;IACA,sBAAA;ECDF;EDIA;IACE,gBAAA;IACA,yBAAA;ECFF;EDKA;IACE,aAAA;IACA,YAAA;IACA,iBAAA;ECHF;AACF;ADOA;EACE,aAAA;ACLF;;ADSA;EACE;IACE,aAAA;IACF,yBAAA;IACE,mBAAA;IACA,UAAA;IACA,YAAA;ECNF;AACF","sourcesContent":["@import \"../../utilities/mixins\";\n@import \"../../utilities/variables\";\n\n.content-layout {\n  background-color: #e4e6eb !important;\n  padding-left: 0px !important;\n  margin: 0px !important;\n  display: flex !important;\n  justify-content: flex-start;\n  align-items: flex-start;\n  height: 100vh;\n}\n\n.view-container-page {\n  @include settingsPage();\n  height: \"100%\";\n  margin-top: -1.5rem;\n}\n\n.container-quickAccess-logged-layout {\n  padding-left: 0px !important;\n  position: sticky !important;\n  top: 0px;\n  background-color: #e4e6eb;\n}\n\n.container-data-layout {\n  height: 100vh;\n  background-color: #e4e6eb !important;\n  justify-content: space-around;\n  align-items: flex-start;\n  align-self: flex-start;\n}\n\n.children{\n  min-height: 68vh;\n}\n\n.quick-access-mobile-displaced {\n  margin-top: 0.5rem !important;\n  transition: margin-top 0.3s; /* Add a transition for smooth animation */\n}\n\n.navbar-component {\n  padding-right: 0;\n  width: calc(100% - 250px);\n}\n\n.loginbutton-component {\n  display: flex;\n  width: 250px;\n  padding-left: 0px\n}\n\n\n.navbar-layout {\n  align-self: center;\n  margin: 50px 5px 30px 5px;\n  .navbar-light {\n    background-color: #ffc14d;\n    border-top-left-radius: 37px;\n    border-bottom-left-radius: 37px;\n    height: 3rem;\n  }\n}\n\n.container-quick-access-layout {\n  align-self: flex-start;\n  position: sticky !important;\n  top: 0px !important;\n  height: 100vh;\n  background-color: $Transparent;\n  padding-left: 0px !important;\n}\n\n@media screen and (max-width: 1200px) {\n  .view-container-page {\n    padding: 0 !important;\n    margin: 0px 64px !important;\n    width: calc(100vw - 65px) !important;\n    height: \"100%\";\n  }\n\n  .container-quickAccess-logged-layout {\n    display: none !important;\n  }\n  .container-quick-access-layout {\n    display: none;\n  }\n}\n\n@media (max-width: 576px) {\n  .view-container-page {\n    background-color: #f7f8f9;\n    padding: 0 !important;\n    margin: 0px 0px !important;\n    width: 100% !important;\n  }\n\n  .navbar-component {\n    padding-right: 0;\n    width: calc(100% - 210px);\n  }\n  \n  .loginbutton-component {\n    display: flex;\n    width: 210px;\n    padding-left: 0px\n  }\n  \n}\n\n.quick-access-mobile {\n  display: none;\n\n}\n\n@media (max-width: 576px) {\n  .quick-access-mobile {\n    display: flex;\n  background-color: #ffffff;\n    border-radius: 17px;\n    width: 85%;\n    margin: auto;\n  }\n}",".content-layout {\n  background-color: #e4e6eb !important;\n  padding-left: 0px !important;\n  margin: 0px !important;\n  display: flex !important;\n  justify-content: flex-start;\n  align-items: flex-start;\n  height: 100vh;\n}\n\n.view-container-page {\n  background-color: rgb(247, 248, 249) !important;\n  padding-right: 0 !important;\n  padding-left: 0 !important;\n  margin-right: 0 !important;\n  margin-left: 0 !important;\n  height: \"100%\";\n  margin-top: -1.5rem;\n}\n\n.container-quickAccess-logged-layout {\n  padding-left: 0px !important;\n  position: sticky !important;\n  top: 0px;\n  background-color: #e4e6eb;\n}\n\n.container-data-layout {\n  height: 100vh;\n  background-color: #e4e6eb !important;\n  justify-content: space-around;\n  align-items: flex-start;\n  align-self: flex-start;\n}\n\n.children {\n  min-height: 68vh;\n}\n\n.quick-access-mobile-displaced {\n  margin-top: 0.5rem !important;\n  transition: margin-top 0.3s; /* Add a transition for smooth animation */\n}\n\n.navbar-component {\n  padding-right: 0;\n  width: calc(100% - 250px);\n}\n\n.loginbutton-component {\n  display: flex;\n  width: 250px;\n  padding-left: 0px;\n}\n\n.navbar-layout {\n  align-self: center;\n  margin: 50px 5px 30px 5px;\n}\n.navbar-layout .navbar-light {\n  background-color: #ffc14d;\n  border-top-left-radius: 37px;\n  border-bottom-left-radius: 37px;\n  height: 3rem;\n}\n\n.container-quick-access-layout {\n  align-self: flex-start;\n  position: sticky !important;\n  top: 0px !important;\n  height: 100vh;\n  background-color: rgba(0, 0, 0, 0);\n  padding-left: 0px !important;\n}\n\n@media screen and (max-width: 1200px) {\n  .view-container-page {\n    padding: 0 !important;\n    margin: 0px 64px !important;\n    width: calc(100vw - 65px) !important;\n    height: \"100%\";\n  }\n  .container-quickAccess-logged-layout {\n    display: none !important;\n  }\n  .container-quick-access-layout {\n    display: none;\n  }\n}\n@media (max-width: 576px) {\n  .view-container-page {\n    background-color: #f7f8f9;\n    padding: 0 !important;\n    margin: 0px 0px !important;\n    width: 100% !important;\n  }\n  .navbar-component {\n    padding-right: 0;\n    width: calc(100% - 210px);\n  }\n  .loginbutton-component {\n    display: flex;\n    width: 210px;\n    padding-left: 0px;\n  }\n}\n.quick-access-mobile {\n  display: none;\n}\n\n@media (max-width: 576px) {\n  .quick-access-mobile {\n    display: flex;\n    background-color: #ffffff;\n    border-radius: 17px;\n    width: 85%;\n    margin: auto;\n  }\n}\n\n","@import \"./variables\";\n\n@mixin flexCenter($justify-content, $align-items) {\n  display: flex;\n  justify-content: $justify-content;\n  align-items: $align-items;\n}\n\n@mixin settingsPage() {\n  background-color: $MainBackgroundColor !important;\n  padding-right: 0 !important;\n  padding-left: 0 !important;\n  margin-right: 0 !important;\n  margin-left: 0 !important;\n}\n","// Utils\n$DecorationNone: none;\n$Font: \"Lato\", sans-serif !important;\n$Font-size-navbar: 12px;\n$LetterSpacing: 0px;\n\n// Colors\n$Transparent: rgba(0, 0, 0, 0);\n$RedColor: rgb(143, 0, 60, 1);\n$White: rgba(255, 255, 255, 1);\n$Black: rgba(26, 25, 25, 1);\n$MainBackgroundColor: rgba(247, 248, 249, 1);\n$SecondaryBackgroundColor: rgba(221, 208, 208, 0.5);\n$GrayColor: rgba(204, 204, 204, 1);\n$LinkColor: rgba(18, 101, 183, 1);\n$LinkSecondColor: rgba(78, 125, 162, 1);\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
